import random from "lodash/random";
import "./LoginImage.scss";

// get new images: https://picsum.photos/700/1600

const imageModules = import.meta.glob("../../../assets/images/sidebar/*.{png,jpg,svg}", {
    eager: true,
    query: "?url",
    import: "default",
});
const imageUrls = Object.values(imageModules);
const randomIndex = imageUrls.length > 0 ? random(0, imageUrls.length - 1) : 0;
const randomImageUrl = imageUrls[randomIndex] ?? "";

const LoginImage = () => (
    <img className="login-image" src={randomImageUrl} alt="Welcome to Cloudomation" />
);

export default LoginImage;
